import { ANALYTICS_SUITE_TAB_IDS } from '../types/navigation';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchReportCollectionTemplates, selectIsReportCollectionTemplateRequestPending } from '../../redux/reportCollectionTemplates';
import { Discover } from '../components/Discover';
import { useDispatch, useSelector } from 'react-redux';
import { AnalyticsSuite } from '../components/AnalyticsSuite';
import { UseCaseFilters } from '../components/UseCaseFilters';
import { useCategoryTemplates } from '../hooks/useCategoryTemplates';
import { useMostPopularTemplates } from '../hooks/useMostPopularTemplates';
import { AnalyticsSuiteHeader } from '../components/AnalyticsSuiteHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AnalyticsSuiteContainer = () => {
  var _mostPopularTemplates;
  const dispatch = useDispatch();
  const {
    tabId: activeTabId
  } = useParams();
  const loading = useSelector(selectIsReportCollectionTemplateRequestPending);
  useEffect(() => {
    void dispatch(fetchReportCollectionTemplates());
  }, [dispatch]);
  const categories = useCategoryTemplates();
  const mostPopularTemplates = useMostPopularTemplates();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AnalyticsSuiteHeader, {}), /*#__PURE__*/_jsx(UseCaseFilters, {}), !loading && (activeTabId === ANALYTICS_SUITE_TAB_IDS.DISCOVER ? /*#__PURE__*/_jsx(Discover, {
      mostPopularTemplates: ((_mostPopularTemplates = mostPopularTemplates[activeTabId]) === null || _mostPopularTemplates === void 0 ? void 0 : _mostPopularTemplates.slice(0, 6)) || []
    }) : /*#__PURE__*/_jsx(AnalyticsSuite, {
      categories: categories[activeTabId] || [],
      mostPopularTemplates: mostPopularTemplates[activeTabId] || []
    }))]
  });
};